import React from "react";
import useWindowDimensions from "../../util/windowUtils";
import { PlayerInfoCard } from "../games/zones/status/PlayerStatus";

export default function PlayerDataDemo() {
    const { height } = useWindowDimensions();

    return <div style={{
        position: "relative",
        backgroundColor: "#555555",
        width: "100%",
        height: `${height - 56}px`,
        overflow: "hidden",
        zIndex: 0,
    }}>
        <PlayerInfoCard
            name="Test Player"
            health={20}
            school="Manifest"
            poolFocus={0}
            nextTurnFocus={0}
            deckCount={40}
            discardCount={0}
            ritualIntensity={1}
            scale={2}
        />
    </div>
}